import posthog from 'posthog-js';

const apiKey = process.env.VUE_APP_POSTHOG_KEY;
const apiHost = process.env.VUE_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

let initialized = false;

export function initAnalytics() {
    if (!apiKey || initialized) return;

    posthog.init(apiKey, {
        api_host: apiHost,
        defaults: '2026-05-30',
        capture_pageview: false, // captured manually on route change, see router/router.js
        capture_pageleave: true, // capture_pageview: false disables this by default
    });
    initialized = true;
}

export function trackPageview(path) {
    if (!initialized) return;
    posthog.capture('$pageview', { $current_url: window.location.origin + path });
}

export function trackEvent(name, properties) {
    if (!initialized) return;
    posthog.capture(name, properties);
}

export function captureError(error, properties) {
    if (!initialized) return;
    posthog.captureException(error, properties);
}

export default posthog;
